import script from "./ServiceSchemesPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceSchemesPanel.vue?vue&type=script&setup=true&lang=js"

import "./ServiceSchemesPanel.vue?vue&type=style&index=0&id=11bfd966&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11bfd966"]])

export default __exports__